import React, { useState, useEffect } from "react";

export default function CALENDERtest(props) {
  const correctAnswers = [2, 1, 1, 2, 1, 2, 1, 2, 1, 0, 2, 1, 0, 0, 2, 2, 1, 1, 2, 0, 1, 3, 3, 2, 0];
  const que = {
    q1: {
      string: "1. If today is Monday, what day will it be after 99 days?",
      options: ["Monday", "Tuesday", "Wednesday", "Thursday"],
      ans: 2
    },
    q2: {
      string: "2. How many days are there in a leap year?",
      options: ["365", "366", "367", "364"],
      ans: 1
    },
    q3: {
      string: "3. What is the next leap year after 2020?",
      options: ["2022", "2024", "2026", "2028"],
      ans: 1
    },
    q4: {
      string: "4. If January 1st is a Friday, what day will March 3rd be in the same year?",
      options: ["Tuesday", "Wednesday", "Thursday", "Friday"],
      ans: 1
    },
    q5: {
      string: "5. How many odd days are there in a non-leap year?",
      options: ["364", "365", "366", "367"],
      ans: 1
    },
    q6: {
      string: "6. What day was it 3 days ago if tomorrow is Thursday?",
      options: ["Sunday", "Monday", "Tuesday", "Wednesday"],
      ans: 2
    },
    q7: {
      string: "7. How many days are there in February during a non-leap year?",
      options: ["27", "28", "29", "30"],
      ans: 1
    },
    q8: {
      string: "8. If October 1st is on a Friday, what day will it be on October 31st of the same year?",
      options: ["Saturday", "Sunday", "Monday", "Tuesday"],
      ans: 2
    },
    q9: {
      string: "9. In a week, what day comes after Tuesday?",
      options: ["Monday", "Wednesday", "Thursday", "Friday"],
      ans: 1
    },
    q10: {
      string: "10. If today is February 29th, what is the year?",
      options: ["A leap year", "A non-leap year", "A leap or non-leap year", "None of the above"],
      ans: 0
    },
    q11: {
      string: "11. What day of the week is it if it was Sunday 3 days ago?",
      options: ["Thursday", "Friday", "Saturday", "Monday"],
      ans: 3
    },
    q12: {
      string: "12. In a leap year, how many days are there in February?",
      options: ["28", "29", "30", "31"],
      ans: 1
    },
    q13: {
      string: "13. What day is it if it is 4 days before Friday?",
      options: ["Monday", "Tuesday", "Wednesday", "Thursday"],
      ans: 1
    },
    q14: {
      string: "14. What is the next leap year after 2030?",
      options: ["2032", "2034", "2036", "2038"],
      ans: 0
    },
    q15: {
      string: "15. How many days are there in April?",
      options: ["28", "29", "30", "31"],
      ans: 3
    },
    q16: {
      string: "16. If August 1st is on a Monday, what day will August 31st be on the same year?",
      options: ["Tuesday", "Wednesday", "Thursday", "Friday"],
      ans: 2
    },
    q17: {
      string: "17. What day is it if it is 5 days after Wednesday?",
      options: ["Sunday", "Monday", "Tuesday", "Saturday"],
      ans: 2
    },
    q18: {
      string: "18. What day of the week is it if it was Tuesday 2 days ago?",
      options: ["Sunday", "Monday", "Wednesday", "Thursday"],
      ans: 0
    },
    q19: {
      string: "19. What day will it be after 25 days if today is Monday?",
      options: ["Monday", "Tuesday", "Wednesday", "Thursday"],
      ans: 2
    },
    q20: {
      string: "20. If March 1st is on a Monday, what day will it be on March 31st of the same year?",
      options: ["Tuesday", "Wednesday", "Thursday", "Friday"],
      ans: 0
    },
    q21: {
      string: "21. What day was it yesterday if today is Sunday?",
      options: ["Friday", "Saturday", "Monday", "Tuesday"],
      ans: 1
    },
    q22: {
      string: "22. How many months have 30 days?",
      options: ["4", "5", "6", "7"],
      ans: 2
    },
    q23: {
      string: "23. If April 1st is on a Thursday, what day will it be on April 30th of the same year?",
      options: ["Friday", "Saturday", "Sunday", "Monday"],
      ans: 3
    },
    q24: {
      string: "24. What day of the week is it if it was Monday 5 days ago?",
      options: ["Thursday", "Friday", "Saturday", "Sunday"],
      ans: 3
    },
    q25: {
      string: "25. If today is July 4th, what is the next day?",
      options: ["July 5th", "July 6th", "July 7th", "July 8th"],
      ans: 0
    }
  };

  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };

  return (
    <div className={props.mode}>
      <div className="heading">
        <h1>APTITUDE <span>CALENDER</span> </h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1> 
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
          <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
